//  Enregistre les trades du bot dans localStorage → Analytics les lit

// 
// TELEGRAM CONFIG
// 

function getTelegramConfig() {
  try {
    const stored = localStorage.getItem('telegram-config');
    return stored ? JSON.parse(stored) : null;
  } catch { return null; }
}

export function saveTelegramConfig({ token, chatId }) {
  try {
    localStorage.setItem('telegram-config', JSON.stringify({ token, chatId }));
  } catch {}
}

export function clearTelegramConfig() {
  localStorage.removeItem('telegram-config');
}

export function getTelegramStatus() {
  const cfg = getTelegramConfig();
  return { configured: !!(cfg?.token && cfg?.chatId), token: cfg?.token, chatId: cfg?.chatId };
}

//  Envoie un message Telegram avec retry (3x, backoff exponentiel)
async function sendTelegram(message, retries = 3) {
  const cfg = getTelegramConfig();
  if (!cfg?.token || !cfg?.chatId) return;
  for (let i = 0; i < retries; i++) {
    try {
      const r = await fetch(`https://api.telegram.org/bot${cfg.token}/sendMessage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chat_id: cfg.chatId, text: message, parse_mode: 'HTML' }),
      });
      if (r.ok) return;
      const err = await r.json().catch(() => ({}));
      console.warn('[BOT] Telegram erreur:', err.description);
    } catch (e) {
      if (i === retries - 1) { console.warn('[BOT] Telegram abandon après', retries, 'tentatives:', e.message); return; }
    }
    await new Promise(res => setTimeout(res, Math.pow(2, i) * 1000));
  }
}

//  Test de connexion Telegram
export async function testTelegram() {
  const cfg = getTelegramConfig();
  if (!cfg?.token || !cfg?.chatId) return { ok: false, error: 'Non configuré'};
  try {
    const r = await fetch(`https://api.telegram.org/bot${cfg.token}/sendMessage`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body: JSON.stringify({
        chat_id:    cfg.chatId,
        text:       '<b>COPY.EXE Bot connecté !</b>\n\nTes alertes de trading sont activées ',
        parse_mode: 'HTML',
      }),
    });
    const j = await r.json();
    if (j.ok) return { ok: true };
    return { ok: false, error: j.description };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

// 
// MESSAGES TELEGRAM PAR TYPE D'ÉVÉNEMENT
// 

export async function notifyBuy({ symbol, mint, amountSol, achatUsd, signature, walletSuivi }) {
  const msg =
`<b>ACHAT COPIÉ</b>

Token: <b>${symbol}</b>
Montant: <b>${amountSol} SOL</b> (~$${achatUsd?.toFixed(2)})
Wallet suivi: <code>${walletSuivi?.slice(0,8)}...${walletSuivi?.slice(-4)}</code>
TX: <a href="https://solscan.io/tx/${signature}">Voir sur Solscan</a>`;
  await sendTelegram(msg);
}

export async function notifySell({ symbol, pctSold, pnlUsd, roi, reason, signature }) {
  const emoji  = (pnlUsd || 0) >= 0 ? '🟢': '';
  const pnlStr = (pnlUsd || 0) >= 0 ? `+$${pnlUsd?.toFixed(2)}`: `-$${Math.abs(pnlUsd||0).toFixed(2)}`;
  const msg =
`${emoji} <b>VENTE — ${reason}</b>

Token: <b>${symbol}</b>
Vendu: <b>${pctSold}%</b>
PNL: <b>${pnlStr}</b>
ROI: <b>${(roi||0) >= 0 ? '+': ''}${roi?.toFixed(1)}%</b>
TX: <a href="https://solscan.io/tx/${signature}">Voir sur Solscan</a>`;
  await sendTelegram(msg);
}

export async function notifyStopLoss({ symbol, pnlPct, pnlUsd, signature }) {
  const msg =
`<b>STOP-LOSS DÉCLENCHÉ</b>

Token: <b>${symbol}</b>
Perte: <b>${pnlPct?.toFixed(1)}%</b> (-$${Math.abs(pnlUsd||0).toFixed(2)})
Position fermée automatiquement
TX: <a href="https://solscan.io/tx/${signature}">Voir sur Solscan</a>`;
  await sendTelegram(msg);
}

export async function notifyTakeProfit({ symbol, pnlPct, pnlUsd, signature }) {
  const msg =
`🟢 <b>TAKE-PROFIT DÉCLENCHÉ</b>

Token: <b>${symbol}</b>
Gain: <b>+${pnlPct?.toFixed(1)}%</b> (+$${pnlUsd?.toFixed(2)})
Position fermée automatiquement 
TX: <a href="https://solscan.io/tx/${signature}">Voir sur Solscan</a>`;
  await sendTelegram(msg);
}

export async function notifyError({ action, symbol, error }) {
  const msg =
`<b>ERREUR BOT</b>

Action: <b>${action}</b>
Token: <b>${symbol || '?'}</b>
Erreur: <code>${error}</code>`;
  await sendTelegram(msg);
}

export async function notifyBotStart(configCount) {
  const msg =
`<b>BOT DÉMARRÉ</b>

${configCount} wallet(s) en écoute
Détection: temps réel (WebSocket)
Stop-loss / Take-profit: actifs`;
  await sendTelegram(msg);
}

export async function notifyBotStop() {
  await sendTelegram('<b>BOT ARRÊTÉ</b>');
}

// 
// LOGS LOCAUX
// 

//  isSim, botWalletId, tokenAmount et prixEntree maintenant sauvegardés
export function logBotTrade({ symbol, mint, entreeTs, sortieTs, achatUsd, venteUsd, pnlUsd, roi, resultat, walletSuivi, txHash, botWalletId, tokenAmount, prixEntree, isSim }) {
  try {
    const existing = JSON.parse(localStorage.getItem('bot-trades') || '[]');
    const trade = {
      id:          Date.now(),
      symbol:      symbol || 'UNKNOWN',
      mint,
      entreeTs:    entreeTs || Math.floor(Date.now() / 1000),
      sortieTs,
      achatUsd:    achatUsd || 0,
      venteUsd:    venteUsd || 0,
      pnlUsd:      pnlUsd || 0,
      roi:         roi || 0,
      roiPos:      (roi || 0) >= 0,
      resultat:    resultat || 'En cours',
      walletSuivi,
      txHash,
      //  Champs essentiels pour la simulation
      botWalletId: botWalletId || null,
      tokenAmount: tokenAmount || 0,
      prixEntree:  prixEntree || 0,
      isSim:       isSim || false,
    };
    localStorage.setItem('bot-trades', JSON.stringify([...existing, trade]));
    console.log(`[BOT] Trade enregistré: ${symbol} ${resultat} isSim:${isSim} PNL: $${pnlUsd?.toFixed(2)}`);
    return trade;
  } catch (e) {
    console.error('[BOT] Erreur log trade:', e);
  }
}

export function logBotEvent(message, data = {}) {
  const timestamp = new Date().toLocaleTimeString('fr-FR');
  console.log(`[BOT ${timestamp}] ${message}`, data);
  try {
    const logs = JSON.parse(localStorage.getItem('bot-logs') || '[]');
    logs.unshift({ timestamp, message, data });
    if (logs.length > 100) logs.pop();
    localStorage.setItem('bot-logs', JSON.stringify(logs));
  } catch {}
}

export function getBotLogs() {
  try { return JSON.parse(localStorage.getItem('bot-logs') || '[]'); }
  catch { return []; }
}

export function clearBotLogs() {
  localStorage.removeItem('bot-logs');
}